import { shallowMount, createLocalVue } from '@vue/test-utils';
import VueCookies from 'vue-cookies';
import ColorSatisfaction from './ColorSatisfaction';

const localVue = createLocalVue();
localVue.use(VueCookies);


const product = {
  id: 34,
  name: 'Modena Brown 5.5 NNN',
  short_description: 'Dark Brown for resistant grays'
};

let trackEventMock = jest.fn();

const createWrapper = ($route = { query: {} }) => {
  return shallowMount(ColorSatisfaction, {
    localVue,
    propsData: {
      invoiceId: 123456,
      product
    },
    mocks: {
      trackEvent: trackEventMock,
      $route
    }
  });
};

describe('ColorSatisfaction', () => {
  const readCookieOnMountSpy = jest.spyOn(ColorSatisfaction.methods, 'readCookieOnMount');
  const readQueryParamsSpy = jest.spyOn(ColorSatisfaction.methods, 'readQueryParams');
  const toggleSurveySpy = jest.spyOn(ColorSatisfaction.methods, 'toggleSurvey');

  afterEach(() => {
    trackEventMock.mockClear();
    readCookieOnMountSpy.mockClear();
    readQueryParamsSpy.mockClear();
    toggleSurveySpy.mockClear();
  });

  test('general snapshot', () => {
    const wrapper = createWrapper();
    expect(wrapper.html()).toMatchSnapshot();
  });

  test('displays product.name correctly', () => {
    const wrapper = createWrapper();
    expect(wrapper.find('.prod-title').text()).toBe(product.name);
  });

  test('displays product.short_description correctly', () => {
    const wrapper = createWrapper();
    expect(wrapper.find('.prod-short-desc').text()).toBe(product.short_description);
  });

  describe('methods', () => {
    describe('rate', () => {
      test('should return correct urls', () => {
        const wrapper = createWrapper();
        const surveyUrl = `/survey/color-satisfaction?oid=${wrapper.vm.invoiceId}&p=${wrapper.vm.product.id}&utm_campaign=color_satisfaction_survey_v3&rating=`;
        expect(wrapper.vm.rate(0)).toEqual(`${surveyUrl}0`);
        expect(wrapper.vm.rate(1)).toEqual(`${surveyUrl}1`);
        expect(wrapper.vm.rate(2)).toEqual(`${surveyUrl}2`);
        expect(wrapper.vm.rate("3")).toEqual(`${surveyUrl}3`);
      });
    });

    describe('toggleSurvey', () => {
      let wrapper;

      beforeEach(() => {
        wrapper = createWrapper();
      });

      test('should set hideSurvey to the opposite Boolean value', () => {
        expect(wrapper.vm.hideSurvey).toEqual(false);
        wrapper.vm.toggleSurvey();
        expect(wrapper.vm.hideSurvey).toEqual(true);
        wrapper.vm.toggleSurvey();
        expect(wrapper.vm.hideSurvey).toEqual(false);
      });

      test('should set it to the Boolean value passed in', () => {
        expect(wrapper.vm.hideSurvey).toEqual(false);
        wrapper.vm.toggleSurvey(true);
        expect(wrapper.vm.hideSurvey).toEqual(true);
        wrapper.vm.toggleSurvey(true);
        expect(wrapper.vm.hideSurvey).toEqual(true);
        wrapper.vm.toggleSurvey(true);
        expect(wrapper.vm.hideSurvey).toEqual(true);
        wrapper.vm.toggleSurvey(false);
        expect(wrapper.vm.hideSurvey).toEqual(false);
        wrapper.vm.toggleSurvey(false);
        expect(wrapper.vm.hideSurvey).toEqual(false);
      });

      test('should set colorSatCookie to same value as hideSurvey', () => {
        expect(wrapper.vm.$cookies.get(wrapper.vm.colorSatCookie)).toEqual("false");
        wrapper.vm.toggleSurvey();
        expect(wrapper.vm.$cookies.get(wrapper.vm.colorSatCookie)).toEqual("true");
        wrapper.vm.toggleSurvey();
        expect(wrapper.vm.$cookies.get(wrapper.vm.colorSatCookie)).toEqual("false");
      });

      test('should call trackEvent when user hides Color Sat survey', () => {
        wrapper.vm.toggleSurvey();
        expect(wrapper.vm.hideSurvey).toEqual(true);
        expect(wrapper.vm.trackEvent).toHaveBeenCalledTimes(1);
      });
    });

    describe('readCookeOnMount', () => {
      test('should set hideSurvey based on colorSatCookie', () => {
        const wrapper = createWrapper();
        wrapper.vm.$cookies.set(wrapper.vm.colorSatCookie, true);
        wrapper.vm.readCookieOnMount();
        expect(wrapper.vm.hideSurvey).toEqual(true);
        //- one more time!
        wrapper.vm.$cookies.set(wrapper.vm.colorSatCookie, false);
        wrapper.vm.readCookieOnMount();
        expect(wrapper.vm.hideSurvey).toEqual(false);
      });

    });

    describe('readQueryParams', () => {
      test('call toggleSurvey when route.query has param colorsurvey and its set to not_colored', () => {
        const $route = {
          name: 'Some Name',
          query: {
            colorsurvey: 'not_colored'
          }
        };

        const wrapper = createWrapper($route);
        wrapper.vm.readQueryParams();
        expect(toggleSurveySpy).toHaveBeenCalled();
      });
    });
  });

  describe('mounted hook', () => {
    test('call expected methods', () => {
      createWrapper();
      expect(readCookieOnMountSpy).toHaveBeenCalledTimes(1);
      expect(readQueryParamsSpy).toHaveBeenCalledTimes(1);
    });
  });
});
